import { createGenericSlice } from './generic.slice'
import { jobExtraReducers } from '@editor/store/reducers/job.reducer'

export const jobUrl = 'job'
export enum JobState {
  ARTICLE_STATE = 'ARTICLE',
  SSML_STATE = 'SSML',
  AUDIO_STATE = 'AUDIO',
  PUBLISHED_STATE = 'PUBLISHED',
  ACTIONNEEDED_STATE = 'ACTION_NEEDED',
}

export interface JobModel {
  id: string
  article: string
  name: string
  ssml: string
  audio: string
  state: JobState
  usedVoiceName: string
  usedSecondaryVoiceName: string
  usedTemplateName: string
  createdBy: string
  createdAt: string
  updatedBy: string
  updatedAt: string
}

const {
  slice: jobSlice,
  thunks: jobThunks,
  adapter: jobAdapter,
} = createGenericSlice<JobModel>(
  'Job',
  jobUrl,
  {},
  jobExtraReducers // Initial state can be customized if needed
)

export const jobAdapterExport = jobAdapter

export const {
  fetchAll: fetchAllJobs,
  fetchById: fetchJobById,
  update: updateJob,
} = jobThunks

export const { removeAll: deleteAllJobs } = jobSlice.actions
export default jobSlice.reducer
